import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * Directive that prevents browser caching of images by appending a timestamp
 * query parameter to the src URL.
 * 
 * This is useful when the same URL is returned from the server but the image
 * content has been updated - the browser would otherwise serve the cached version.
 * 
 */
@Directive({
  selector: '[noCacheSrc]',
  standalone: true
})
export class NoCacheSrcDirective implements OnChanges {
  @Input() noCacheSrc: string | null | undefined;

  constructor(private el: ElementRef<HTMLImageElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['noCacheSrc']) {
      this.updateSrc();
    }
  }

  private updateSrc(): void {
    if (!this.noCacheSrc) {
      this.el.nativeElement.src = '';
      return;
    }

    if (this.noCacheSrc.startsWith('data:') || this.noCacheSrc.startsWith('blob:')) {
      this.el.nativeElement.src = this.noCacheSrc;
      return;
    }

    // Check if URL already has query parameters
    const separator = this.noCacheSrc.includes('?') ? '&' : '?';
    const cacheBustedUrl = `${this.noCacheSrc}${separator}_t=${Date.now()}`;
    
    this.el.nativeElement.src = cacheBustedUrl;
  }
}

